import protoRoot from "../proto-root";
import LullabyPlayerSettings from "../private/LullabyPlayerSettings";

const name = "playLullabyRpcRequest";

function create(settings) {
  const PlayLullabyRpcRequest = protoRoot.lookupType(
    "comm.PlayLullabyRpcRequest"
  );

  const request = PlayLullabyRpcRequest.create({
    settings: LullabyPlayerSettings.create(settings)
  });

  return { payload: request, name };
}

export default {
  create,
  name
};

// message PlayLullabyRpcRequest {
//   LullabyPlayerSettings settings = 1;
// }
